<div class="modal fade" role="dialog" [ngStyle]="{'display': spinner}" aria-hidden="true" style="opacity: 1">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</div>

<!-- .cssload-inner.cssload-three -->